import { render, staticRenderFns } from "./NotificationDialog.vue?vue&type=template&id=1c8430b0"
import script from "./NotificationDialog.vue?vue&type=script&lang=js"
export * from "./NotificationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports